/* eslint-disable no-new-object */

import * as Constants from "utils/Constants";

import { COMMON } from "redux/constants/action-types";
import HelperFunctions from "utils/HelperFunctions";
import axios from "axios";
import toast from "utils/toast";
export const IdentityServerURL = import.meta.env.VITE_IdentityServerURL;

export function updateClientID(payload) {
  return {
    type: COMMON.DROP_DOWN_CLICK,
    payload,
  };
}
export function updateIncludeCongloms(payload) {
  return {
    type: COMMON.INCLUDE_CONGLOMS,
    payload,
  };
}

export function updateMenuClickInformation(payload) {
  return {
    type: COMMON.MENU_CLICK_INFORMATION,
    payload,
  };
}

export function setDesignGuid(payload) {
  return {
    type: COMMON.DESIGN_GUID,
    payload,
  };
}

export function loadBrandsDropdown(URL) {
  return async function (dispatch) {
    try {
      const response = await axios.get(URL);

      dispatch({
        type: COMMON.DROP_DOWN_FILL,
        payload: response.data,
      });
    } catch (error) {
      console.log("error", error);
    }
  };
}

export function loadTotalContactsData(clientId) {
  return async function (dispatch) {
    try {
      const response = await axios.get(Constants.VNEXT_BASE_URL + "Report/DatabaseOverview/GetTotalContactsByMarketingChannel" + "?clientId=" + clientId);
      dispatch({
        type: COMMON.UPDATE_TOTAL_CONTACTS,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error);
    }
  };
}

export function GetCountsForPeopleCustomersProspects(clientId) {
  return async function (dispatch) {
    try {
      const response = await axios.get(
        Constants.VNEXT_BASE_URL + "Report/DatabaseOverview/GetCountsForPeopleCustomersProspects" + "?clientId=" + clientId
      );
      dispatch({
        type: COMMON.COUNTS_FOR_PEOPLE_CUSTOMER_PROSPECT,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error);
    }
  };
}

export function loadDataSources(clientId) {
  return async function (dispatch) {
    try {
      const response = await axios.get(
        Constants.VNEXT_BASE_URL +
        "Report/DatabaseOverview/GetDataSources?clientId=" +
        clientId
      );

      dispatch({
        type: COMMON.RECENT_SOURCES_UPDATE,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error);
    }
  };
}

export function updateRecentLoadTab(payload) {
  return {
    type: COMMON.RECENT_LOADS_UPDATE,
    payload,
  };
}

export function GetClient(clientId) {
  return async function (dispatch) {
    try {

      let URL = Constants.VNEXT_BASE_URL + 'shared/GetClient?clientId=' + clientId;

      const response = await axios.get(URL);

      dispatch({
        type: COMMON.GET_CLIENT,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getUser(clientId) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + "shared/getUser?clientId=" + clientId;

      const response = await axios.get(URL);

      const ls_lastLogin = localStorage.getItem("user.lastLoginDate");
      const userName = response.data?.content?.userName;
      if (!ls_lastLogin && userName) {
        const userLastLoginDate = response.data.content.lastLoginDate;

        // Last Login Update Logic
        let LLURL = IdentityServerURL + "api/shared/UpdateLastLogin";
        const LLResponse = await axios.get(LLURL + "?Email=" + encodeURIComponent(userName));

        if (LLResponse.data.operationSuccessful && userLastLoginDate) {
          const dateToUpdate = new Date(userLastLoginDate);
          const options = {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
          };

          const formattedDate = dateToUpdate.toLocaleString('en-US', options);
          const [month, day, year] = formattedDate.split(',')[0].split('/');
          const timePart = formattedDate.split(',')[1].trim();

          const finalFormattedDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')} ${timePart}`
          
          localStorage.setItem("user.lastLoginDate", finalFormattedDate)
        }
      }
      // Last Login Update Logic

      const color = response.data?.content?.badgeColor || '#96C0FF';
      localStorage.setItem("badgeColor", color);
      document.documentElement.style.setProperty('--badge-color', color);

      const isDark = HelperFunctions.isColorDark(color) || '#0082be';
      localStorage.setItem("isBadgeColorDark", isDark)
      const colorIcon = isDark ? '#FFFFFF' : '#000000';
      document.documentElement.style.setProperty('--badge-color-Icon', colorIcon);

      dispatch({
        type: COMMON.GET_USER,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function loadRecentDataLoad(clientId) {
  return async function (dispatch) {
    try {
      const response = await axios.get(
        Constants.VNEXT_BASE_URL +
        "Report/DatabaseOverview/GetRecentDataLoad?clientId=" +
        clientId
      );
      let temp = {
        recentDataLoads: HelperFunctions.responseHandlerVNext(response.data),
        recentDataLoadsTab: "peopleTab",
      };
      dispatch({
        type: COMMON.RECENT_LOADS_UPDATE,
        payload: temp,
      });
    } catch (error) {
      console.log("error", error);
    }
  };
}

export function getProviders(clientId) {
  return async function (dispatch) {
    try {
      const response = await axios.get(
        Constants.VNEXT_BASE_URL +
        "FormBuilder/Editor/GetProvidersByClient?clientId=" +
        clientId
      );

      dispatch({
        type: COMMON.PROVIDERS,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function GetDefaultValues(clientId) {
  return async function (dispatch) {
    try {
      let URL =
        Constants.VNEXT_BASE_URL +
        "shared/GetDefaultValues?clientId=" +
        clientId;

      const response = await axios.get(URL);

      const data = HelperFunctions.responseHandlerVNext(response.data);
      dispatch({
        type: COMMON.GET_DEFUALT_VALUES,
        payload: data,
      });
      return data;
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getClientList(includeCongloms) {
  return async function (dispatch) {
    try {
      //console.log('Common.js getClientList before call');
      let URL =
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
        `shared/GetClientList?includeCongloms=${includeCongloms}`;
      const response = await axios.get(URL);
      const responseData = HelperFunctions.responseHandlerVNext(response.data);

      // if(responseData && responseData.length > 0){
      //   const selectedClientId = HelperFunctions.getCookie("selectedClientId");
      //   const clientId = selectedClientId ? selectedClientId : responseData[0].clientId; 
      //   dispatch(getClientUserClaims(clientId));        
      // }

      //console.log('Common.js getClientList after call', response);
      dispatch({
        type: COMMON.GET_CLIENT_LIST,
        payload: responseData,
      });
    } catch (error) {
      console.log("error", error);
    }
  };
}

export function getClientUserClaims(clientId) {
  return async function (dispatch) {
    try {
      let URL =
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
        "Configuration/UserManagement/GetClientUserClaims?clientId=" +
        clientId;
      const response = await axios.get(URL);
      const responseData = HelperFunctions.responseHandlerVNext(response.data);

      // localStorage.setItem(
      //   "ClientUserClaims-" + clientId, responseData
      // );
      dispatch({
        type: COMMON.GET_CLIENT_USER_CLAIMS,
        payload: responseData,
      });
    } catch (error) {
      console.log("error", error);
    }
  };
}

export function exportFile(url) {
  return async function (dispatch) {
    try {
      //document.getElementById("spinner-wrapper").style.display = "block";
      const response = await axios.get(url);
      if (response.data && response.data.operationSuccessful) {
        toast.success("Export File Operation Successful.");
      }
      else {
        toast.error("Export File Operation Failed.");
      }
    } catch (error) {
      console.log("error", error);
    }
  };
}

export function downloadFile(url, fileName, ext) {
  return async function (dispatch) {
    try {
      axios({
        url: url,
        method: "GET",
        responseType: "blob",
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName + "." + ext);
        document.body.appendChild(link);
        link.click();
      });
    } catch (error) {
      console.log("error", error);
    }
  };
}

export function showLoader(status) {
  if (status) {
    if (document.getElementById("spinner-wrapper")) {
      document.getElementById("spinner-wrapper").style.display = "block";
    }
  } else {
    if (document.getElementById("spinner-wrapper")) {
      document.getElementById("spinner-wrapper").style.display = "none";
    }
  }
}

export function showLoaderForcely(status) {
  if (status) {
    if (document.getElementById("spinner-wrapper-old")) {
      document.getElementById("spinner-wrapper-old").style.display = "block";
    }
  } else {
    if (document.getElementById("spinner-wrapper-old")) {
      document.getElementById("spinner-wrapper-old").style.display = "none";
    }
  }
}

export function downloadFileFromBlob(blob, fileName) {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
}

// Enhanced download function that returns a proper promise for proper async handling
export function downloadFileV2(url, fileName) {
  return axios({
    url: url,
    method: "GET",
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      "X-Suppress-Toast": "true" // Suppress success toast for downloads
    },
  }).then(response => {
    downloadFileFromBlob(response.data, fileName);
    return response;
  });
}

export function insertPortalAccessLog(clientId, clientName, resource, logType) {
  return async function (dispatch) {
    try {
      let URL =
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
        `shared/InsertPortalAccessLog?clientId=${clientId}&clientName=${encodeURIComponent(
          clientName
        )}&resource=${encodeURIComponent(resource)}&logType=${logType}`;
      const response = await axios.get(URL);
      dispatch({
        type: COMMON.INSERT_PORTAL_ACCESS_LOG,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error);
    }
  };
}

export function GetZendeskURL() {
  return async function (dispatch) {
    try {
      let URL = (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) + `zendesk/sso/login`;
      const response = await axios.get(URL);
      window.open(response.data.url);
    } catch (error) {
      console.log("error", error);
    }
  };
}
